module.exports = __webpack_public_path__ + "static/media/astellas.77caa4fe.png";